

























import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
// import contact from './contact.vue'
@Component
export default class PayRollTax extends Vue {
    @Prop({ type: String })
    period: any;

    @Prop({ type: Boolean })
    isTax?: false;

    file: any = null;
    isLastMonth: number = 0;
    changeFile(e: any) {
        if (e.target.files[0]) {
            this.file = e.target.files[0];
        }
    }
    confirmInput() {
        if (!this.isTax) {
            Vue.axios
                .post(
                    `tax/record/save?period=${this.period}&ids=${
                        this.$store.state.accountBook.id
                    }&flowType=${2}&isLastMonth=${this.isLastMonth}`,
                    {}
                )
                .then((res) => {
                    this.$confirm(`亲，请前往税模块查看提交情况！`, "温馨提示").then(
                        (action: any) => {
                            this.$emit("success", this.isLastMonth);
                        }
                    );
                    this.$emit("success");

                    // this.fetchData();
                });
        }else{
            this.$emit("success", this.isLastMonth);
        }
    }
    close() {
        this.$emit("close");
    }
}
